import React, { useMemo } from 'react';
import { OPERATION_TYPE } from "../../../../../util/varibles/constants";
import { IDiseaseOfSite, ITaskTreatment, ITreatment2, IUnit } from "../../../../../util/varibles/interface";
import Tabs from "../../../../Basic/Tabs";
import Icon, { ICON_NAME } from "../../../../Icon";
import UnitDisease from "../../../../Operation/FishDisease/UnitDisease";
import Round from "../../../../Operation/Round";
import TankDensities from "../../../../Operation/TankDensities";
import TaskView from '../../../../Operation/Task/TaskView';
import UnitLice from "../../../../Operation/UnitLice";
import FishHealthInfo from "../../_component/FishHealthInfo";
import LineInfo from "../../_component/LineInfo";
import AvgAmountTotal from "../../_component/UnitInfo/AvgAmountTotal";
import stylesContainer from "../../style.module.scss";

interface IProps {
    data: ITreatment2
}

const UnitInfo: React.FC<{
    data?: IUnit,
    diseases?: IDiseaseOfSite[],
    tasks?: { [id: string]: ITaskTreatment[] }
}> = ({ data, diseases = [], tasks = {} }) => {
    if (!data)
        return null;

    const {
        id,
        avg_weight = 0,
        fish_amount = 0,
        total_weight = 0,
        note = "",
        lice,
        fish_health,
        storages
    } = data;

    return <>
        <AvgAmountTotal className='mb-1' data={{ avg_weight, fish_amount, total_weight }} />
        <div className='mb-1'>
            <Round unit={data} />
        </div>
        <LineInfo label="Lice per fish (Adult female lice, Mobile, Stationary)" icon
            className="mb-1 pl-1">
            <>
                <Icon className="mt-[1px]" icon={ICON_NAME.LICE} />
                <UnitLice lice={lice || (diseases[0] || {}).lice} />
            </>
        </LineInfo>
        <div className="mb-1">
            <FishHealthInfo value={fish_health} />
        </div>
        <LineInfo label="Unit diseases" className='mb-1' icon>
            <>
                <Icon className="mt-[2px]" icon={ICON_NAME.DISEASE} />
                <UnitDisease unit={data} />
            </>
        </LineInfo>
        <LineInfo label="Fish group ID" className='mb-1 mt-[4px]' icon>
            <>
                {data.fish_group || "-"}
            </>
        </LineInfo>
        <div className='mb-[8px]'>
            <TankDensities type={OPERATION_TYPE.TREATMENT} storages={storages} />
        </div>
        {note.length > 0 && <div className={[stylesContainer['container-box'], 'mb-10 pl-1'].join(' ')}>
            <div>Unit's note:</div>
            <div className='ml-[1px]'>{note}</div>
        </div>}
        <TaskView tasks={tasks[id] || []} />
    </>
}

const Tasks: React.FC<IProps> = ({ data }) => {
    const { sub_operations, tasks, diseases = [] } = data;
    const tasksByUnit = tasks.reduce((rs: { [id: string]: ITaskTreatment[] }, item) => {
        const { id = "", } = item.sub_operation || {};
        rs[id] = [...rs[id] || [], item];
        return rs;
    }, {});

    const tabs = useMemo(() => sub_operations.map(item => ({
        name: item.unit_id,
        data: item
    })), [sub_operations]);

    return <Tabs opts={tabs}>
        <UnitInfo tasks={tasksByUnit} diseases={diseases} />
    </Tabs>;
};

export default Tasks;
